import React from 'react'
import classNames from 'classnames'
import { BannerBlock } from './banner-parser'
import { ScriptContent } from './script-parser-effects'
import { Skeleton } from '@dustin-web/microsite-components/src/skeleton'

type Props = {
  block: BannerBlock
  fullscreen?: boolean
  skeletons?: boolean
}

export const Banner = ({ block: group, fullscreen = false, skeletons = true }: Props) => {
  const BannerSkeleton = () =>
    skeletons ? (
      <div className="u-absolute u-w-100 u-h-100 u-px-8" style={{ left: '0' }}>
        <Skeleton className="u-w-100 u-h-100" />
      </div>
    ) : null

  return (
    <>
      <div
        className={classNames('d-relative c-startpage-banner c-startpage-banner--hero d-none', {
          'd-lg-block': fullscreen,
        })}>
        <BannerSkeleton />
        <ScriptContent src={group.hero} />
      </div>
      <div
        className={classNames(
          'd-relative c-startpage-banner c-startpage-banner--divided d-none d-md-block',
          {
            'd-lg-none': fullscreen,
          }
        )}>
        <BannerSkeleton />
        <ScriptContent src={group.divided} />
      </div>
      <div className="d-relative c-startpage-banner d-md-none">
        <BannerSkeleton />
        <ScriptContent src={group.mobile} />
      </div>
    </>
  )
}
